import moment from "moment";
import { Currencies as CurrencyEnum } from "../shared/dictionary/enums";

export function moneyFormater(amount, decimals) {
  if (decimals > 0) {
    let pow = Math.pow(10, decimals);
    amount = Math.round(amount * pow) / pow;
  } else if (decimals === 0) {
    amount = Math.round(amount);
  }
  amount = amount.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(amount)) amount = amount.replace(pattern, "$1 $2");
  return amount;
}

export function dateTimeFormater(date) {
  return moment(date).format("YYYY-MM-DD H:mm:ss");
}

export function dateFormater(date) {
  return moment(date).format("YYYY-MM-DD");
}

function addForwardZeroFfNeeded(number) {
  return number <= 9 ? "0" + number : "" + number;
}

export function simpleDateFormater(dateValue) {
  let date = new Date(dateValue);
  let year, month, day, monthNumber, dayNumber;

  monthNumber = date.getMonth() + 1;
  dayNumber = date.getUTCDate();

  year = date.getFullYear();
  month = addForwardZeroFfNeeded(monthNumber);
  day = addForwardZeroFfNeeded(dayNumber);

  return year + "-" + month + "-" + day;
}

export function numberWithSpaces(x) {
  if (x || x === 0) {
    let decimals = decimalPlaces(x);
    let number;
    if (decimals > 2) {
      number = trimDecimals(x);
    } else {
      number = x;
    }

    return number
      .toString()
      .replace(/\s/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  } else {
    return "";
  }
}

export function numberWithoutSpaces(x) {
  if (x || x == 0) {
    return x.toString().replace(/\s/g, "");
  } else {
    return undefined;
  }
}

function trimDecimals(num) {
  return Number(Number(num).toFixed(2));
}

function decimalPlaces(num) {
  var match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) {
    return 0;
  }
  return Math.max(
    0,
    // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) -
      // Adjust for scientific notation.
      (match[2] ? +match[2] : 0),
  );
}

export const currencyTag = {
  [CurrencyEnum.Sek]: "SEK",
  [CurrencyEnum.Eur]: "EUR",
};

export const reportTitle = {
  [CurrencyEnum.Sek]: "Sek Report",
  [CurrencyEnum.Eur]: "Euro Report",
};
